import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Form, Row } from "react-bootstrap";
import {
  CustomInput,
  InputLayout,
  SubmitButton,
} from "../components/shared/input";
import dynamic from "next/dynamic";
import { POSTFORM } from "../utils/requests";

const Authentication = dynamic(() =>
  import("../components/Layouts/Authentication")
);

const Signup = () => {
  const router = useRouter();

  const HandleSubmit = async (e) => {
    const x = await POSTFORM(e, "/register");
    if (x?.status === true) {
      router.push("/signin");
    }
  };

  return (
    <Authentication>
      <Form onSubmit={HandleSubmit}>
        <h1 className=" fs-4 fw-bold text-center">Sign Up</h1>
        <p className="text-center mb-4 font-e-lg">
          Enhance Your Shopping Experience With Us
        </p>
        <InputLayout className="overflow-hidden">
          <Row>
            <Col>
              <CustomInput name="name" placeholder="Name" indicator={false} />
            </Col>
            <Col>
              <CustomInput
                name="username"
                placeholder="Username"
                indicator={false}
              />
            </Col>
          </Row>
          <CustomInput
            name="email"
            type="email"
            placeholder="Email"
            indicator={false}
          />
          <CustomInput
            name="password"
            type="password"
            placeholder="Password"
            indicator={false}
          />
        </InputLayout>
        <Row className="justify-content-between mt-3 px-2">
          <Col sm="auto">
            <Link href="/signin">
              <a href="/signin" className="font-md text-info fw-bold">
                Signin
              </a>
            </Link>
          </Col>
          <Col sm="auto">
            <Link href="/forgot">
              <a href="/forgot" className="font-md text-primary fw-bold">
                Forgot Password
              </a>
            </Link>
          </Col>
        </Row>
        <SubmitButton title="Signup" variant="dark rounded-8 my-4 py-2" />
      </Form>
    </Authentication>
  );
};

export default Signup;
